import { render } from "./ParticleAnimation.vue?vue&type=template&id=4865d6da"
import script from "./ParticleAnimation.vue?vue&type=script&lang=js"
export * from "./ParticleAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__